
export const availableMoveTypes = [ 
    {"id": "", "label": "Local","value": "Local", "icon": "icon-local.svg"},
    {"id": "", "label": "MORE THAN 2 HOURS AWAY","value": "ShortHaul", "icon": "icon-shorthaul.svg"},
    {"id": "","label": "OUT OF STATE", "value": "LongDistance", "icon": "icon-ld.svg"}
  ];